import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'

export const SummaryCard = styled(Card, {
  name: 'SummaryCard',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  padding: theme.spacing(2),
  width: '345px',
  '@media (max-width: 1000px)': {
    width: '573px',
  },
}))
